const templateTypes = {
	VERTICAL: 'Vertical',
	HORIZONTAL: 'Horizontal',
	IMAGES: 'Images',
	CIGAR_SHOP_ANDORRA: 'CigarShopAndorra',
};

export { templateTypes };
